export const GET_USER_PERMISSIONS = "MINI_GET_USER_PERMISSIONS";
export const USER_PERMISSIONS_SUCCESSFUL = "MINI_USER_PERMISSIONS_SUCCESSFUL";

export const GET_LOCATIONS = "Mini_get_locations";
export const LOCATION_LIST_SUCCESSFUL = "mini_locaton_list_successfull";
export const GET_SUB_LOCATIONS = "Mini_get_sub_locations";
export const SUB_ORDER_LOCATIONS_LIST = "sub_mini_order_locations_list";
export const SUB_LOCATION_LIST_SUCCESSFUL = "mini_sub_locaton_list_successfull";

export const SUB_ORDER_LOCATION_LIST_SUCCESSFUL =
	"mini_sub_order_locaton_list_successfull";

export const GET_USER_LOCATIONS = "Mini_User_get_locations";
export const USER_LOCATION_LIST_SUCCESSFUL =
	"mini_User_locaton_list_successfull";
export const GET_USER_SUB_LOCATIONS = "Mini_User_get_sub_locations";
export const USER_SUB_LOCATION_LIST_SUCCESSFUL =
	"mini_User_sub_locaton_list_successfull";

export const GET_DEPARTMENT = "Mini_get_Department";
export const DEPARTMENT_LIST_SUCCESSFUL = "Mini_Department_list_successfull";

export const GET_USER_DEPARTMENT = "Mini_User_get_Department";
export const USER_DEPARTMENT_LIST_SUCCESSFUL =
	"Mini_User_Department_list_successfull";

export const GET_STATE = "mini_state";
export const STATE_LIST_SUCCESSFUL = "mini_state_list_successfull";

export const GET_VENDORS = "mini_vendors";
export const VENDORS_LIST_SUCCESSFUL = "mini_vendor_list_successfull";
export const CLEAR_VENDORS_LIST = "clear_mini_vendor_list";

export const GET_VENDORS2 = "mini_vendors2";
export const VENDORS2_LIST_SUCCESSFUL = "mini_vendor2_list_successfull";

export const GET_SUBLOCATIONS2 = "mini_sublocation2";
export const SUBLOCATIONS2_LIST_SUCCESSFUL =
	"mini_sublocation2_list_successfull";
export const CLEAR_SUBLOCATIONS2_LIST = "clear_mini_sublocation2";
export const SUBLOCATIONS2_CHANGE_PARAMS = "mini_sublocation2_change_params";

export const GET_SECTION = "mini_Section";
export const SECTION_LIST_SUCCESSFUL = "mini_Section_list_successfull";

export const GET_CATEGORY = "Mini_Category";
export const CATEGORY_LIST_SUCCESSFUL = "mini_Category_list_successfull";

export const GET_TAX = "mini_Tax";
export const TAX_LIST_SUCCESSFUL = "mini_Taxs_list_successfull";

export const GET_BASICUNIT = "Mini_BasicUnit";
export const BASICUNIT_LIST_SUCCESSFUL = "Mini_BasicUnit_list_successfull";

export const GET_MINI_PRODUCT_GROUPS_LIST = "get_mini_product_groups_list";
export const MINI_PRODUCT_GROUPS_LIST_SUCCESSFUL =
	"mini_product_groups_list_successfull";
export const GET_MINI_PRODUCT_LIST = "masters_mini_products_list";
//export const GET_MINI_PRODUCT_LIST = "masters_mini_products_list";
export const MINI_PRODUCT_LIST_SUCCESSFUL = "get_mini_product_list_successfull";

export const API_ERROR = "api_failed";

export const MINI_SUB_ORDER_LOCATIONS_LIST = "MINI_SUB_ORDER_LOCATIONS_LIST";

export const MINI_SUB_ORDER_LOCATION_LIST_SUCCESSFUL =
	"MINI_SUB_ORDER_LOCATION_LIST_SUCCESSFUL";

export const GET_ProductQualities = "Mini_get_ProductQualities";
export const ProductQualities_LIST_SUCCESSFUL =
	"mini_ProductQualities_list_successfull";

export const GET_MINI_QUALITY_LIST = "masters_mini_QUALITY_list";
//export const GET_MINI_PRODUCT_LIST = "masters_mini_products_list";
export const MINI_QUALITY_LIST_SUCCESSFUL = "get_mini_QUALITY_list_successfull";
